export function graphicHolder() {
    const $window = $(window);
    const graphicSection = $('.graphic-holder');
    const svg = $('.graphic-svg');
    const rotateTime = svg.data('rotate-time');
    const circle = svg.find('.circle');
    const pins = $('.graphic-holder .pins');
    const list = $('.graphic-section .list');
    const SVGGroup = svg.find('.graphic-svg-group');
    const firstGroup = svg.find('.graphic-svg-group').eq(0);
    const firstGroupData = firstGroup.data('group');
    let i = 2;
    let interval;

    list.find('.open-popup').on('click', function () {
        list.find('li').removeClass('active');
        $(this).parent().addClass('active');
    });

    list.find('.close-popup').on('click', function () {
        $(this).closest('li').removeClass('active');
    });


    firstGroup.addClass('hovered').next().addClass('hovered');
    pins.find(`[data-group='${firstGroupData}']`).addClass('active');

    svg.find('.graphic-svg-group').hover(function () {
        const $this = $(this);
        const dataGroup = $this.data('group');

        pins.find('.pin').removeClass('active');
        pins.find(`[data-group='${dataGroup}']`).addClass('active');
        $('.graphic-svg-group').removeClass('hovered');
        $this.addClass('hovered').next().addClass('hovered');
    });

    pins.find('.pin.all').hover(function () {
        $('.graphic-svg-group').addClass('hovered');
        pins.find('.pin').removeClass('active');
        circle.addClass('active');
    }, function () {
        $('.graphic-svg-group').removeClass('hovered');
        circle.removeClass('active');
    });

    graphicSection.hover(function () {
        clearInterval(interval);
    }, function () {
        interval = setInterval(autoRotate, rotateTime);
    })

    function autoRotate() {
        let current = SVGGroup.eq(i++);
        const dataGroup = current.data('group');

        svg.find('.graphic-svg-group').removeClass('hovered');
        pins.find('.pin').removeClass('active');
        current.addClass("hovered").next().addClass('hovered');
        pins.find(`[data-group='${dataGroup}']`).addClass('active');
        circle.removeClass('active');

        i = (i % 8) + 1;
        if (i === 8) {
            svg.find('.graphic-svg-group').addClass('hovered');
            circle.addClass('active');
            pins.find('.pin').addClass('active');
            i = 0;
        }

    }

    $window.on("scroll load", function () {
        if ($window.innerWidth() > 1200 && ($window.scrollTop() > $(graphicSection).offset().top - $window.height() * 0.88) && !$(graphicSection).hasClass('animated')) {
            interval = setInterval(autoRotate, rotateTime);
            graphicSection.addClass('animated');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/graphicHolder.js